import "./PlanningCSS/index.css";
import "./PlanningCSS/overview.css";
import "./PlanningCSS/rich-text-editor.css";
import * as React from "react";
import {
    InsertImage,
    setOrganizationId,
    setProjectId,
} from "./Image/insertImageTool";
import { insertImagePlugin } from "./Image/insertImagePlugin";
import { insertImageFiles } from "./Image/utils";
import { Editor, EditorTools, ProseMirror } from "@progress/kendo-react-editor";
import { ColorPickerComponent } from "@syncfusion/ej2-react-inputs";
import { createElement } from "@syncfusion/ej2-base";
import {
    KanbanComponent,
    ColumnsDirective,
    ColumnDirective,
} from "@syncfusion/ej2-react-kanban";
import { Query } from "@syncfusion/ej2-data";
import { Checkbox } from "@progress/kendo-react-inputs";
import { DropDownList } from "@progress/kendo-react-dropdowns";
import { Upload } from "@progress/kendo-react-upload";
import RemoveDialog from "../Shared/Remove/RemoveDialog";
import PopoverTooltip from "../Shared/Popover/PopoverTooltip";
import { MultiSelect, ComboBox } from "@progress/kendo-react-dropdowns";
import { PageContainer, Content, Header } from "../Drawer/PageContainer";
import { DeleteFile, UploadFiletoDirectory } from "../Helpers/DateLakeStorage";
import Loader from "../Shared/Loader/loader";
import { callApiWithAuthorization } from "../../API/CallApi";
import { Dialog, DialogActionsBar } from "@progress/kendo-react-dialogs";
import Scrollable from "../Shared/Edit/Scrollable";
import { getPlanningItems } from "../../API/Planning/Planning";
import { getOrganizationUsers } from '../../API/Organization/organization';

const {
    Bold,
    Italic,
    Underline,
    AlignLeft,
    AlignRight,
    AlignCenter,
    InsertTable,
    Indent,
    Outdent,
    OrderedList,
    UnorderedList,
    Undo,
    Redo,
    DeleteRow,
    DeleteColumn,
    DeleteTable,
} = EditorTools;

class Planning extends React.Component {
    selectedColor = "#CCE2CB";
    selectedTags = "";
    SelectedDescription = "";
    SelectedAttachments = [];
    assigneeData = [];
    formDialog = React.createRef();
    constructor(props) {
        super(props);
        this.state = {
            data: [],
            allData: [],
            headerData: [],
            loading: true,
            value: "None",
            completeState: "",
            groupvalue: "None",
            areFiltersVisible: false,
            assigneeData: [],
            colorData: {
                custom: [
                    "#d6b027",
                    "#ef612b",
                    "#0e81bdcc",
                    "#da976a",
                    "#da6984",
                    "#489045",
                ],
            },
            groupByData: ["None", "Type", "Priority", "Source", "AssignTo"],
            fields: { text: "id", value: "State" },
            priorityData: [],
            cardTypeData: [],
            stateData: [],
            showFormDialog: false,
            cardDetails: {},
            filters: {
                priority_filter: "None",
                type_filter: "None",
                state_filter: "None",
            },
        };
        this.template = this.rowTemplate;
        setProjectId(this.props.projectId);
        setOrganizationId(this.props.organizationId);
    }

    componentDidMount = async () => {
        let projectUsers = await this.getProjectUsers();
        let requirementsData = await this.getRequirementsData();
        let priorities = requirementsData.priorities
            .slice()
            .sort((a, b) => a.order - b.order);
        priorities = priorities.map((item) => item.key);
        let cardTypes = requirementsData.cardTypes
            .slice()
            .sort((a, b) => a.order - b.order);
        cardTypes = cardTypes.map((item) => item.key);
        let headerData = requirementsData.states
            .slice()
            .sort((a, b) => a.order - b.order);
        let states = headerData.map((item) => item.key);

        // let cardsRequest = await callApiWithAuthorization(
        //     "/api/v0/" +
        //     this.props.projectId +
        //     "/getPlanningItems"
        // );
        // let cardsResult = await cardsRequest.json();
        const cardsResult = await getPlanningItems(this.props.projectId);

        let Tags = cardsResult.map((item) => item.Tags).join(",");
        Tags = Tags.split(",");
        const uniqueSetid = new Set(Tags);
        Tags = [...uniqueSetid];

        window.addEventListener("mousemove", this.drag);

        this.setState({
            data: cardsResult,
            allData: cardsResult,
            tagsData: Tags,
            assigneeData: projectUsers,
            completeState: headerData.find(
                (item) => item.completeState === "true"
            ),
            headerData: [...headerData],
            priorityData: [...this.state.priorityData, ...priorities],
            cardTypeData: [...this.state.cardTypeData, ...cardTypes],
            stateData: [...this.state.stateData, ...states],
            loading: false,
        });
    };

    componentWillUnmount() {
        window.removeEventListener("mousemove", this.drag);
    }

    getRequirementsData = async () => {
        let getRequirementsDataRequest = await callApiWithAuthorization(
            "/api/v0/" +
            this.props.organizationId +
            "/getPlanningData"
        );
        let requirementsData = await getRequirementsDataRequest.json();
        return requirementsData;
    };

    getProjectUsers = async () => {
        const results = await getOrganizationUsers(this.props.organizationId);
        for (let result of results) {
            result.fullName = result.firstName + " " + result.lastName;
        }
        return results;
    };

    onColorChange = (args) => {
        this.selectedColor = args.value;
    };

    onTagsChange = (value) => {
        this.selectedTags = value;
    };

    onDescriptionChange = (value) => {
        this.SelectedDescription = value;
    };

    onAttachmentsChange = (value) => {
        this.SelectedAttachments = [...this.SelectedAttachments, ...value];
    };

    onRemoveAttachmentsChange = (value) => {
        this.SelectedAttachments = value;
    };

    rowTemplate(props) {
        let user = { ...props };
        if (this.state.groupvalue === "AssignTo") {
            let data = this.state.assigneeData.find(
                (u) => u.email === props.textField
            );
            user.textField = data ? data.fullName : "Unassigned";
        }
        return (
            <div className="swimlane-template e-swimlane-template-table">
                <div className="e-swimlane-row-text">
                    <span>
                        {this.state.groupvalue === "Priority"
                            ? "Priority : "
                            : null}
                        &nbsp;{user.textField}
                    </span>
                </div>
            </div>
        );
    }

    columnTemplate = (props) => {
        return (
            <div className="header-template-wrap">
                <div className="header-text">{props.headerText} </div>
            </div>
        );
    };

    cardTemplate(props) {
        return (
            <div
                style={{ borderLeft: "5px solid" + props.color }}
                className={"card-template"}
            >
                <div className="e-card-header">
                    <div className="e-card-header-caption">
                        <div className="e-card-header-title e-tooltip-text">
                            {props.id} - {props.type}
                            {props.type === "Feedback" &&
                                props.source === "Runtime" && (
                                    <i className="float-end fad fa-comments-alt"></i>
                                )}
                        </div>
                    </div>
                </div>
                {props.title.length > 0 ? (
                    <div className="e-card-content e-tooltip-text">
                        <div className="e-text">
                            {props.title.length > 258
                                ? props.title.substr(0, 256) + "..."
                                : props.title}
                        </div>
                    </div>
                ) : (
                    <div className="e-card-content e-tooltip-text">
                        <div className="e-text-red">Please Provide Title</div>
                    </div>
                )}
                {props.tags !== "" && (
                    <div className="e-card-custom-footer">
                        {props.tags.split(",")
                            .slice(0, 5)
                            .map((tag) => (
                                <div className="e-card-tag-field e-tooltip-text">
                                    {tag}
                                </div>
                            ))}
                        {props.tags.split(",").length > 5 && (
                            <div className="e-card-tag-field e-tooltip-text text-secondary">
                                + {props.tags.split(",").length - 5} more
                            </div>
                        )}
                    </div>
                )}
                <div className="flex-wrap e-card-custom-footer bottom-bar">
                    {props.assignTo === null || props.assignTo === undefined ? (
                        <div className="text-danger f-12">Unassigned</div>
                    ) : (
                        <div className="e-card-avatar">
                            &nbsp;{this.getString(props.assignTo)}
                        </div>
                    )}
                    <div className="items-center d-flex">
                        {props.attachments && props.attachments.length > 0 && (
                            <div
                                style={{ padding: "0", paddingTop: "5px" }}
                                className="e-card-header"
                            >
                                <div className="e-card-header-caption">
                                    <span className="e-card-source">
                                        <i className="fas fa-paperclip"></i>
                                    </span>
                                </div>
                            </div>
                        )}
                        <div className="e-card-header">
                            <div className="e-card-header-caption text-nowrap">
                                <span className="e-card-source">
                                    Priority : {props.priority}
                                </span>
                            </div>
                        </div>
                        <Checkbox
                            title="Move to Complete State"
                            style={{
                                marginTop: "5px",
                                border: "1px solid rgb(14 134 35)",
                            }}
                            onChange={() => this.markAsComplete(props.cardId)}
                            disabled={props.state === this.state.completeState?.key ? true : false}
                            checked={props.state === this.state.completeState?.key ? true : false}
                        ></Checkbox>
                    </div>
                </div>
            </div>
        );
    }

    getString(assignee) {
        let user = this.state.assigneeData.find((u) => u.email === assignee);
        let field = user.firstName ? "fullName" : "email";
        return user[field]
            .match(/\b(\w)/g)
            .join("")
            .toUpperCase();
    }

    addItem = (e) => {
        const cardDetails = {
            id: this.state.data.length + 1,
            state: this.state.stateData[0],
            priority: this.state.priorityData[0],
            assignTo: this.state.assigneeData[0]?.email,
            tags: "",
            title: "",
            efforts: "",
            attachments: [],
            type: this.state.cardTypeData[0],
            description: "",
            isNew: true,
            shouldAdd: true,
            createdBy: this.props.user.email,
            source: "Designer",
            color: this.state.colorData.custom[0],
        };
        this.setState({
            cardDetails,
            showFormDialog: true,
        });
        // this.kanbanObj.openDialog('Add', cardDetails);
    };

    closeFormDialog = (e) => {
        const { cardData, action } = e;

        let oldData = this.state.allData.find(
            (card) => card.id === cardData.id
        );

        if (
            oldData &&
            cardData.Description !== oldData.Description &&
            action === "update"
        ) {
            var div = document.createElement("div");
            div.innerHTML = cardData.Description;
            var Images = div.getElementsByTagName("img");

            let imageNames = [];
            for (let item of Images) {
                if (item && item.src !== "") {
                    let splitElement =
                        this.props.projectId + "/PlanningImages/";
                    let imageName = item.src.split(splitElement);
                    // let path = this.props.organizationId + "/" + this.props.projectId + "/PlanningImages/" + imageName[1]
                    imageNames.push(imageName[1]);
                }
            }

            var div2 = document.createElement("div");
            div2.innerHTML = oldData.Description;
            var Images = div2.getElementsByTagName("img");

            let OldimageNames = [];

            for (let item of Images) {
                if (item && item.src !== "") {
                    let splitElement =
                        this.props.projectId + "/PlanningImages/";
                    let imageName = item.src.split(splitElement);
                    // let path = this.props.organizationId + "/" + this.props.projectId + "/PlanningImages/" + imageName[1]
                    OldimageNames.push(imageName[1]);
                }
            }

            if (OldimageNames.length < imageNames.length) {
                let deletedItem = imageNames.filter(
                    (image) => !OldimageNames.includes(image)
                );

                for (let item of deletedItem) {
                    let path =
                        this.props.organizationId +
                        "/" +
                        this.props.projectId +
                        "/PlanningImages/" +
                        item;
                    DeleteFile(path, item);
                }
            }
        }
        if (cardData.description !== "" && action === "create") {
            var div = document.createElement("div");
            div.innerHTML = cardData.Description;
            var Images = div.getElementsByTagName("img");

            for (let item of Images) {
                if (item && item.src !== "") {
                    let splitElement =
                        this.props.projectId + "/PlanningImages/";
                    let imageName = item.src.split(splitElement);
                    let path =
                        this.props.organizationId +
                        "/" +
                        this.props.projectId +
                        "/PlanningImages/" +
                        imageName[1];
                    DeleteFile(path, imageName[1]);
                }
            }
        }
        this.setState({
            cardDetails: {},
            showFormDialog: false,
        });
    };

    submitFormDialog = async (e) => {
        const { cardData, action, tagsData } = e;
        cardData.createdBy = this.props.user.email;
        const data = await this.SaveCard(cardData, action);
        this.setState({
            allData: data,
            data: data,
            cardDetails: {},
            tagsData: tagsData,
            showFormDialog: false,
        });
    };

    toggleFilters = () => {
        this.setState({
            areFiltersVisible: !this.state.areFiltersVisible,
        });
    };

    filter = (e) => {
        let items = this.state.data;
        if (e.target.value !== "") {
            items = items.filter(
                (item) =>
                    item.title.toLowerCase().includes(
                        e.target.value.toLowerCase()
                    ) ||
                    item.type.toLowerCase().includes(
                        e.target.value.toLowerCase()
                    )
            );
        } else {
            items = this.filterData(this.state.filters);
        }
        this.setState({
            data: items,
        });
    };

    change(id, value) {
        const { filters, allData } = this.state;
        filters[id] = value;
        const data = this.filterData(filters);
        this.setState({
            filters,
            data,
        });
    }

    filterData(filters) {
        const filterableFieldsMap = {
            priority_filter: "Priority",
            type_filter: "Type",
            state_filter: "State",
        };
        const { allData } = this.state;
        let data = [...allData];
        for (let filter in filters) {
            if (filters[filter] !== "None") {
                data = data.filter((entry) =>
                    entry[filterableFieldsMap[filter]]
                        .toLowerCase()
                        .includes(filters[filter].toLowerCase())
                );
            }
        }
        return data;
    }

    GroupBy(args) {
        this.setState({
            groupvalue: args.value,
        });
    }

    resetClick = () => {
        document.getElementById("search_text").value = "";
        this.priorityObj.setProperties({ value: "None" }, false);
        this.statusObj.setProperties({ value: "None" }, false);
        this.typeObj.setProperties({ value: "None" }, false);
        this.kanbanObj.query = new Query();
        let data = this.state.allData;
        this.setState({
            data: data,
        });
    };

    dragStart = (e) => {
        e.data[0].drag = true;
        this.initialOffset = [
            e.event.element.offsetLeft - e.event.event.clientX,
            e.event.element.offsetTop - e.event.event.clientY,
        ];
        this.draggedElement = e.event.dragElement;
    };

    drag = (event) => {
        const { draggedElement } = this;
        if (draggedElement) {
            const { initialOffset } = this;
            const { clientX, clientY } = event;
            const { left, top } = draggedElement.style;
            draggedElement.style.left = clientX + initialOffset[0] + "px";
            draggedElement.style.top = clientY + initialOffset[1] + "px";
        }
    };

    dragStop = async (e) => {
        const { data } = e;
        if (data.length === 0) return;
        const result = await this.SaveCard(data[0], "update");
        this.setState({
            data: result,
            allData: result,
        });
    };

    OnActionBegin = async (e) => {
        if (e.requestType === "cardRemove") {
            let result,
                Tags = [];
            result = await this.SaveCard(
                this.kanbanObj.activeCardData.data,
                "remove"
            );
            this.setState({
                data: result,
                allData: result,
            });
        }
    };

    dialogOpen = (e) => {
        e.cancel = true;
        const cardDetails = e.data;
        this.setState({
            cardDetails,
            showFormDialog: true,
        });
    };

    markAsComplete = async (id) => {
        let data = this.kanbanObj.activeCardData.data;
        data.State = this.state.completeState.key;
        let result = await this.SaveCard(data, "update");
        this.setState({
            data: result,
            allData: result,
        });
    };

    uploadAttachments = async (files) => {
        let formData = new FormData();

        files = [
            ...new Map(files.map((item) => [item["name"], item])).values(),
        ];

        for (let attachment of files) {

            if (!attachment.validationErrors) {
                let fileName =
                    attachment.name.split(".jpg" || ".png" || ".pdf")[0] +
                    "_" +
                    new Date().getTime() +
                    attachment.extension;
                formData.append(`file`, attachment.getRawFile(), fileName);
            }
        }

        let path =
            this.props.organizationId +
            "/" +
            this.props.projectId +
            "/PlanningImages";
        formData.append("path", path);

        return await UploadFiletoDirectory(formData);
    };

    removeAttachments = async (deletedAttachments) => {
        const request = await callApiWithAuthorization(
            "/api/v0/planning/deleteAttachment",
            {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    deletedAttachments: deletedAttachments,
                }),
            }
        );
        const response = await request.json();
        return response;
    };

    SaveCard = async (data, action) => {
        try {
            debugger;
            if (data.deletedAttachments && data.deletedAttachments.length > 0) {
                await this.removeAttachments(data.deletedAttachments);
            }
            if (data.newAttachments && data.newAttachments.length > 0) {
                const newAttachments = await this.uploadAttachments(
                    data.newAttachments
                );
                data.attachments = [...data.attachments, ...newAttachments];
                data.newAttachments = newAttachments;
            }
            if (!data.newAttachments) {
                data.newAttachments = [];
            }
            if (!data.deletedAttachments) {
                data.deletedAttachments = [];
            }
            if (!data.attachments) {
                data.attachments = [];
            }
            let oldData = this.state.allData.find(
                (card) => card.id === data.id
            );

            if (
                oldData &&
                data.Description !== oldData.Description &&
                action === "update"
            ) {
                var div = document.createElement("div");
                div.innerHTML = data.Description;
                var Images = div.getElementsByTagName("img");

                let imageNames = [];
                for (let item of Images) {
                    if (item && item.src !== "") {
                        let splitElement =
                            this.props.projectId + "/PlanningImages/";
                        let imageName = item.src.split(splitElement);
                        // let path = this.props.organizationId + "/" + this.props.projectId + "/PlanningImages/" + imageName[1]
                        imageNames.push(imageName[1]);
                    }
                }

                var div2 = document.createElement("div");
                div2.innerHTML = oldData.Description;
                var Images = div2.getElementsByTagName("img");

                let OldimageNames = [];

                for (let item of Images) {
                    if (item && item.src !== "") {
                        let splitElement =
                            this.props.projectId + "/PlanningImages/";
                        let imageName = item.src.split(splitElement);
                        // let path = this.props.organizationId + "/" + this.props.projectId + "/PlanningImages/" + imageName[1]
                        OldimageNames.push(imageName[1]);
                    }
                }

                if (OldimageNames.length > imageNames.length) {
                    let deletedItem = OldimageNames.filter(
                        (image) => !imageNames.includes(image)
                    );

                    for (let item of deletedItem) {
                        let path =
                            this.props.organizationId +
                            "/" +
                            this.props.projectId +
                            "/PlanningImages/" +
                            item;
                        DeleteFile(path, item);
                    }
                }
            }

            if (data.Description !== "" && action === "remove") {
                var div = document.createElement("div");
                div.innerHTML = data.Description;
                var Images = div.getElementsByTagName("img");

                for (let item of Images) {
                    if (item && item.src !== "") {
                        let splitElement =
                            this.props.projectId + "/PlanningImages/";
                        let imageName = item.src.split(splitElement);
                        let path =
                            this.props.organizationId +
                            "/" +
                            this.props.projectId +
                            "/PlanningImages/" +
                            imageName[1];
                        DeleteFile(path, imageName[1]);
                    }
                }
            }

            let request = await callApiWithAuthorization(
                "/api/v0/planning/" +
                this.props.orgName +
                "/" +
                this.props.projectId +
                "/updateItemsData",
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify({
                        _id: data._id,
                        value: data,
                        action: action,
                        key: data.id,
                        organizationId: this.props.organizationId,
                        keyColumn: "id",
                    }),
                }
            );
            let result = await request.json();
            return result;
        } catch (e) {
            console.error(e);
        }
    };

    render() {
        return (
            <>
                {this.state.showFormDialog && (
                    <>
                        <FormDialog
                            ref={this.formDialog}
                            {...this.state.cardDetails}
                            priorityData={this.state.priorityData}
                            cardTypeData={this.state.cardTypeData}
                            colorData={this.state.colorData}
                            stateData={this.state.stateData}
                            tagsData={this.state.tagsData}
                            onColorChange={this.onColorChange}
                            onTagsChange={this.onTagsChange}
                            onAttachmentsChange={this.onAttachmentsChange}
                            onRemoveAttachmentsChange={this.onRemoveAttachmentsChange}
                            onDescriptionChange={this.onDescriptionChange}
                            assigneeData={this.state.assigneeData}
                            closeFormDialog={this.closeFormDialog}
                            submitFormDialog={this.submitFormDialog}
                        />
                    </>
                )}

                <PageContainer>
                    <Header
                        header="Planning"
                        showAction={true}
                        actionText="New item"
                        actionClicked={this.addItem}
                        actionDisabled={false}
                    >
                        <div className="d-flex align-items-baseline justify-content-between me-3 pe-1">
                            <span className="text-nowrap px-2">Group By</span>
                            <DropDownList
                                ref={(kanban) => { this.priorityObj = kanban }}
                                className="form-control-custom"
                                data={this.state.groupByData}
                                value={this.state.groupvalue}
                                onChange={this.GroupBy.bind(this)}
                            />

                            <button
                                className="btn btn-secondary ms-2"
                                onClick={this.toggleFilters}
                            >
                                <i className="fal fa-filter" />
                            </button>
                        </div>
                    </Header>
                    {this.state.loading && <Loader />}
                    <Content>
                        <div className="pt-2 h-100 mx-2">
                            {this.state.areFiltersVisible && (
                                <>
                                    <div className="d-flex align-items-center w-100 py-1">
                                        <div className="mx-2">
                                            <div>&nbsp;</div>
                                            <i className="fal fa-filter mx-1" />
                                        </div>

                                        <div className="mx-2 flex-grow-1">
                                            <div>&nbsp;</div>
                                            <input
                                                id="search_text"
                                                onChange={this.filter}
                                                placeholder="Filter by title"
                                                className="form-control flex-grow-1"
                                            />
                                        </div>

                                        <div className="mx-2">
                                            <div>Priority</div>
                                            <DropDownList
                                                style={{ width: 100 }}
                                                ref={(kanban) => { this.priorityObj = kanban; }}
                                                className="form-control-custom"
                                                data={["None", ...this.state.priorityData]}
                                                onChange={(e) => { this.change('priority_filter', e.target.value) }}
                                            />
                                        </div>

                                        <div className="mx-2">
                                            <div>State</div>
                                            <DropDownList
                                                style={{ width: 100 }}
                                                id="state_filter"
                                                ref={(kanban) => { this.statusObj = kanban; }}
                                                className="form-control-custom"
                                                data={["None", ...this.state.stateData]}
                                                onChange={(e) => { this.change('state_filter', e.target.value) }}
                                            />
                                        </div>

                                        <div className="mx-2">
                                            <div>State</div>
                                            <DropDownList
                                                style={{ width: 100 }}
                                                id="type_filter"
                                                ref={(kanban) => { this.typeObj = kanban; }}
                                                className="form-control-custom"
                                                data={["None", ...this.state.cardTypeData]}
                                                onChange={(e) => { this.change('type_filter', e.target.value) }}
                                            />
                                        </div>
                                        <div className="mx-2">
                                            <div>&nbsp;</div>
                                            <button
                                                id="reset_filter"
                                                className="btn btn-secondary"
                                                onClick={this.resetClick.bind(this)}>
                                                <i class="fas fa-sync mx-1"></i>
                                                Reset
                                            </button>
                                        </div>
                                    </div>
                                </>
                            )}

                            {this.state.groupvalue === "None" ? (
                                <KanbanComponent
                                    id="kanban"
                                    ref={(kanban) => { this.kanbanObj = kanban }}
                                    cssClass="kanban-overview"
                                    keyField="state"
                                    key="None"
                                    allowToggle={true}
                                    allowDragAndDrop={true}
                                    dragStart={this.dragStart.bind(this)}
                                    dragStop={this.dragStop}
                                    actionBegin={this.OnActionBegin.bind(this)}
                                    dataSource={this.state.data}
                                    cardSettings={{
                                        headerField: "id",
                                        template: this.cardTemplate.bind(this),
                                    }}
                                    dialogOpen={this.dialogOpen}
                                    dialogSettings={{
                                        model: { width: "60%" },
                                        template: this.dialogTemplate,
                                    }}
                                >
                                    <ColumnsDirective>
                                        {this.state.headerData.map(
                                            (data, index) => (
                                                <ColumnDirective
                                                    headerText={data.key}
                                                    keyField={data.key}
                                                    allowToggle={
                                                        this.state.data.length >
                                                            0
                                                            ? true
                                                            : false
                                                    }
                                                    template={this.columnTemplate.bind(
                                                        this
                                                    )}
                                                />
                                            )
                                        )}
                                    </ColumnsDirective>
                                </KanbanComponent>
                            ) : (
                                <>
                                    <KanbanComponent
                                        id="kanban"
                                        ref={(kanban) => {
                                            this.kanbanObj = kanban;
                                        }}
                                        cssClass="kanban-overview"
                                        keyField="State"
                                        allowKeybard={false}
                                        key="grouped"
                                        allowToggle={
                                            this.state.data.length > 0
                                                ? true
                                                : false
                                        }
                                        dragStart={this.dragStart.bind(this)}
                                        dragStop={this.dragStop}
                                        allowDragAndDrop={true}
                                        actionBegin={this.OnActionBegin.bind(this)}
                                        dataSource={this.state.data}
                                        swimlaneSettings={{
                                            showEmptyRow: true,
                                            showItemCount: true,
                                            allowToggle: true,
                                            showUnassignedRow: true,
                                            keyField:
                                                this.state.groupvalue === "None"
                                                    ? ""
                                                    : this.state.groupvalue,
                                            template: this.template.bind(this),
                                            allowDragAndDrop:
                                                this.state.groupvalue ===
                                                    "Source"
                                                    ? false
                                                    : true,
                                            allowCustomValue: true,
                                        }}
                                        cardSettings={{
                                            contentField: "title",
                                            headerField: "id",
                                            template:
                                                this.cardTemplate.bind(this),
                                        }}
                                        dialogOpen={this.dialogOpen}
                                        dialogSettings={{
                                            model: { width: 600 },
                                            template: this.dialogTemplate,
                                        }}
                                    >
                                        <ColumnsDirective>
                                            {this.state.stateData.map(
                                                (data, index) => (
                                                    <ColumnDirective
                                                        headerText={data}
                                                        keyField={data}
                                                        allowToggle={
                                                            this.state.data
                                                                .length > 0
                                                                ? true
                                                                : false
                                                        }
                                                        template={this.columnTemplate.bind(
                                                            this
                                                        )}
                                                    />
                                                )
                                            )}
                                        </ColumnsDirective>
                                    </KanbanComponent>
                                </>
                            )}
                        </div>
                    </Content>
                </PageContainer>

                {/* 
                <div className='schedule-control-section'>
                    <div className='col-lg-12 control-section' style={{ height: "calc(100% + -2px)", overflowY: "auto" }}>
                        <div className="d-f jc-sb">                                   
                        </div>                    
                    </div>            
                </div> */}
            </>
        );
    }
}

class FormDialog extends React.Component {
    saveButton = React.createRef();

    dialog = React.createRef();
    AttachmentsData = [];
    userRender = (li, itemProps) => {
        const user = itemProps;
        const itemChildren = (
            <div style={{ display: "flex", alignItems: "center" }}>
                <div className="mx-1 circle multi-user-circle d-inline-block d-center " style={{ background: user.dataItem.bgColor, color: "#fff" }} >
                    {user.dataItem.email.substring(0, 2).toUpperCase()}
                </div>
                &nbsp;&nbsp;&nbsp;&nbsp;
                <div>
                    <h6>{user.dataItem.displayName}</h6>
                    {user.dataItem.email}
                </div>
            </div>
        );
        return React.cloneElement(li, li.props, itemChildren);
    };

    constructor(props) {
        super(props);
        let { tags } = props;
        if (tags && tags.length > 0) {
            tags = tags.split(",");
        }
        const assignTo = props.assigneeData.find(
            (u) => u.email === props.assignTo
        );
        this.state = {
            assigneeData: props.assigneeData,
            priorityData: props.priorityData,
            tagsData: props.tagsData,
            cardTypeData: props.cardTypeData,
            colorData: props.colorData,
            stateData: props.stateData,
            shouldAdd: props.shouldAdd,
            tagsHtmlAttributes: { name: "Tags" },
            id: props.id,
            portalName: props.portalName,
            instance: props.instance,
            pageName: props.pageName,
            pageUrl: props.pageUrl,
            userName: props.userName,
            createdBy: props.createdBy,
            userRole: props.userRole,
            state: props.state,
            priority: props.priority,
            assignTo: assignTo,
            tooltipAnchor: {},
            showTooltip: false,
            tags: tags,
            color: props.color,
            efforts: props.efforts,
            source: props.source,
            title: props.title,
            type: props.type,
            attachments: props.attachments || [],
            description: props.description,
            isNew: props.isNew,
            id: props.id,
            showDeleteDialog: false,
            cover: [],
            deletedAttachments: [],
            _id: props._id

        };
        this.fields = { text: "fullName", value: "email" };
        this.tooltipAnchor = React.createRef();


    }

    componentDidMount() {
        // this.removeAttachmentDialog.hide();
    }

    isSaveDisabled = (e) => {
        const numAttachments = this.state.attachments.length;
        const numAddedAttachments = this.state.cover.length;
        return (
            this.state.title.trim() === "" ||
            numAttachments + numAddedAttachments > 3
        );
    };

    render() {

        if (this.state.showDeleteDialog) {
            return (
                <RemoveDialog
                    Title="Delete card"
                    message={`Are you sure you want to remove ${this.props.id} - ${this.props.type} card?`}
                    onDelete={(e) => {
                        this.onSubmit(e, "remove");
                    }}
                    deleteButtonText="Delete"
                    toggleDeleteDialog={this.toggleDeleteDialog}
                />
            );
        }

        return (
            <>
                <Dialog
                    width={"85%"}
                    height={"85%"}
                    title={this.state.isNew ? 'Create new Item' : (this.state.id + "-" + this.state.type)}
                    onClose={this.closeFormDialog}>
                    <form onSubmit={this.onSubmit} className="h-100">
                        <dif className="d-flex flex-column h-100">
                            <div>
                                <textarea
                                    autoFocus
                                    rows={2}
                                    placeholder="Enter title"
                                    name="title"
                                    className="form-control"
                                    value={this.state.title}
                                    onChange={this.onChange}
                                    style={{ resize: "none" }}
                                ></textarea>
                            </div>
                            <div className="flex-grow-1">
                                <div className="row m-0 mt-2 h-100">
                                    <div className="col-8 p-0 pe-1">
                                        <Scrollable>
                                            <div className="form-label">
                                                Description
                                            </div>
                                            <Editor
                                                animate={false}
                                                tools={[
                                                    [Bold, Italic, Underline],
                                                    [AlignLeft, AlignCenter, AlignRight,],
                                                    [OrderedList, UnorderedList, Indent, Outdent,],
                                                    [InsertImage],
                                                    [InsertTable, DeleteRow, DeleteColumn, DeleteTable,],
                                                    [Undo, Redo],
                                                ]}
                                                value={this.state.description}
                                                defaultEditMode={"div"}
                                                onMount={this.onMount}
                                                contentStyle={{ height: 280 }}
                                                onChange={this.handleDescription}
                                            />

                                            <div className="d-flex align-items-center">
                                                <div className="flex-grow-1">
                                                    <div className="form-label">
                                                        attachments<i
                                                            name="Tags"
                                                            data-tooltip="You can upload maximum 3 files of type .pdf, .doc, .docx, .txt, .ppt, .pptx, .jpg, .png, .gif, .mp4, .bmp less than 4mb"
                                                            onMouseEnter={
                                                                this.handleTooltip
                                                            }
                                                            onMouseOut={this.handleTooltip}
                                                            ref={this.tooltipAnchor}
                                                            className="fal fa-info-circle mx-1"
                                                        ></i>
                                                    </div>
                                                </div>
                                                <div>
                                                    <small className="text-danger ">
                                                        {this.state.showAttachmentsMessage && "Maximum three attachments are allowed!"}
                                                    </small>
                                                    <PopoverTooltip
                                                        showTitle={false}
                                                        show={this.state.showTooltip}
                                                        target={
                                                            this.state.tooltipAnchor
                                                        }
                                                    />
                                                </div>
                                            </div>

                                            <div>
                                                <Upload
                                                    className="create-project-upload"
                                                    multiple={true}
                                                    autoUpload={false}
                                                    name="cover"
                                                    onAdd={this.addFile}
                                                    onRemove={this.removeFile}
                                                    files={this.state.cover}
                                                    restrictions={{
                                                        allowedExtensions: [
                                                            ".jpg",
                                                            ".png",
                                                            ".pdf",
                                                            ".docx",
                                                            ".doc",
                                                            ".txt",
                                                            ".ppt",
                                                            ".pptx",
                                                            ".mp4",
                                                            ".bmp",
                                                            ".gif",
                                                        ],
                                                        maxFileSize: 4000000,
                                                    }}
                                                />
                                            </div>

                                            <div>
                                                {this.state.attachments.map((item) => {
                                                    return (
                                                        <div className="py-2 row">
                                                            <div className="col-11">
                                                                <a target="_blank" href={process.env.REACT_APP_DESIGNER_API_URL + "/files/planningImages/" + item}>
                                                                    {item}
                                                                </a>
                                                            </div>
                                                            <div className="col-1">
                                                                <span onClick={() => this.showRemoveAttachmentDialog(item)}>
                                                                    <i className="fal fa-times text-danger" />
                                                                </span>
                                                            </div>
                                                        </div>
                                                    );
                                                })}
                                            </div>

                                        </Scrollable>

                                    </div>
                                    <div className="col-4 p-1 bg-2">
                                        <div className="h-100 d-flex flex-column">
                                            <table>
                                                <tbody>
                                                    <tr>
                                                        <td className="form-label ps-1 pe-2 py-3 text-nowrap">
                                                            Add Tags
                                                        </td>
                                                        <td>
                                                            <MultiSelect
                                                                id="customelement"
                                                                data={this.state.tagsData}
                                                                name="tags"
                                                                value={this.state.tags}
                                                                allowCustom={true}
                                                                placeholder="Select Tags"
                                                                onChange={this.onDropDownChange}
                                                            />
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td className="form-label ps-1 pe-2 py-3 text-nowrap">
                                                            Card Type
                                                        </td>
                                                        <td>
                                                            <DropDownList
                                                                id="Type"
                                                                name="type"
                                                                className="form-control-custom"
                                                                data={this.state.cardTypeData}
                                                                enabled={this.state.source === "Runtime" ? false : true}
                                                                placeholder="Select Card Type"
                                                                value={this.state.type}
                                                                onChange={this.onDropDownChange}
                                                                allowCustom={false}
                                                            ></DropDownList>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td className="form-label ps-1 pe-2 py-3 text-nowrap">
                                                            State
                                                        </td>
                                                        <td>
                                                            <DropDownList
                                                                id="State"
                                                                name="state"
                                                                className="form-control-custom"
                                                                enabled={this.state.isNew ? false : true}
                                                                data={this.state.stateData}
                                                                placeholder="Select State"
                                                                value={this.state.state}
                                                                onChange={this.onDropDownChange}
                                                                allowCustom={false}
                                                            ></DropDownList>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td className="form-label ps-1 pe-2 py-3 text-nowrap">
                                                            Assign to
                                                        </td>
                                                        <td>
                                                            <ComboBox
                                                                id="AssignTo"
                                                                name="assignTo"
                                                                className="form-control-custom"
                                                                placeholder="Select User"
                                                                itemRender={this.userRender}
                                                                data={this.state.assigneeData}
                                                                value={this.state.assignTo}
                                                                onChange={this.onDropDownChange}
                                                                textField={this.state.assignTo && this.state.assignTo.firstName ? "fullName" : "email"}
                                                                dataItemKey="email"
                                                                allowCustom={false}
                                                            />
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td className="form-label ps-1 pe-2 py-3 text-nowrap">
                                                            Priority
                                                        </td>
                                                        <td>
                                                            <DropDownList
                                                                name="priority"
                                                                className="form-control-custom"
                                                                value={this.state.priority}
                                                                data={this.state.priorityData}
                                                                placeholder="Select Priority"
                                                                onChange={this.onDropDownChange}
                                                                allowCustom={false}
                                                            ></DropDownList>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td className="form-label ps-1 pe-2 py-3 text-nowrap">
                                                            Card Color
                                                        </td>
                                                        <td>
                                                            <div className="p-0 col-xs-12 col-sm-12 col-lg-6 col-md-6 e-circle-wrap">
                                                                <ColorPickerComponent
                                                                    id="circle-palette"
                                                                    mode="Palette"
                                                                    modeSwitcher={false}
                                                                    inline={true}
                                                                    showButtons={false}
                                                                    columns={6}
                                                                    presetColors={this.state.colorData}
                                                                    value={this.state.color}
                                                                    beforeTileRender={this.beforeCircleTileRender.bind(this)}
                                                                    change={this.onColorChange}
                                                                ></ColorPickerComponent>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                            <div className="flex-grow-1"></div>
                                            <table>
                                                <tbody>
                                                    <tr>
                                                        <td className="form-label ps-1 pe-2 grey text-nowrap">
                                                            Source
                                                        </td>
                                                        <td className="font-weight-bold">
                                                            {this.state.source}
                                                        </td>
                                                    </tr>
                                                    {this.state.isNew ? null : (
                                                        <tr>
                                                            <td className="form-label ps-1 pe-2 grey text-nowrap">
                                                                Created by
                                                            </td>
                                                            <td className="font-weight-bold">
                                                                {this.state.createdBy}
                                                            </td>
                                                        </tr>
                                                    )}
                                                    {this.state.source === "Runtime" &&
                                                        <tr>
                                                            <td></td>
                                                            <td className="font-weight-bold">
                                                                {this.state.portalName} -
                                                                {this.state.instance} :
                                                                <a target="_blank" href={this.state.pageUrl}>
                                                                    {this.state.pageName}
                                                                </a>
                                                                - submitted by {this.state.userName} as {this.state.userRole}
                                                            </td>
                                                        </tr>
                                                    }
                                                </tbody>
                                            </table>

                                        </div>

                                    </div>
                                </div>
                            </div>
                        </dif>



                    </form>
                    <DialogActionsBar layout="end">
                        <div className="d-flex align-items-center w-100 mb-2 mx-2">
                            <div className="flex-grow-1">
                                {!this.props.isNew &&
                                    <button onClick={this.toggleDeleteDialog}
                                        className="btn btn-danger">Delete</button>
                                }
                            </div>
                            <div>
                                <button
                                    onClick={this.closeFormDialog}
                                    className="btn btn-secondary mx-2">
                                    Cancel
                                </button>
                                <button
                                    onClick={(e) => { const event = this.props.isNew ? "insert" : "update"; this.onSubmit(e, event); }}
                                    ref={this.saveButton}
                                    disabled={this.isSaveDisabled()}
                                    className="btn btn-primary"> Save
                                </button>
                            </div>
                        </div>
                    </DialogActionsBar>
                </Dialog>

                {this.state.showRemoveAttachment && (
                    <Dialog
                        title="Remove Attachment"
                        width="400px"
                        height="180px"
                        className="remove-attachment-dialog"
                    >
                        Are you sure you want to remove the attachment?
                        <DialogActionsBar layout="end">
                            <button onClick={this.removeAttachment} className="btn btn-primary">Remove</button>
                            <button onClick={this.hideRemoveAttachmentDialog} className="btn btn-secondary">Cancel </button>
                        </DialogActionsBar>
                    </Dialog>
                )}
            </>
        );
    }

    handleTooltip = (e) => {
        this.setState({
            showTooltip: !this.state.showTooltip,
            tooltipAnchor: e.target,
        });
    };

    beforeCircleTileRender(args) {
        args.element.classList.add("e-circle-palette");
        args.element.appendChild(
            createElement("span", { className: "e-circle-selection" })
        );
    }

    onColorChange = (args) => {
        this.setState({ color: args.value });
        // this.props.onColorChange(args);
    };

    onChange = (args) => {
        let key = args.target.name;
        let value = args.target.value;
        this.setState({ [key]: value });
    };

    onDropDownChange = (args) => {
        const { name, value } = args.target;
        this.setState({ [name]: value });
    };

    handleDescription = (e) => {
        this.setState({ description: e.html });
        // this.props.onDescriptionChange(e.html)
    };

    onImageInsert = (args) => {
        const { files, view, event } = args;
        const nodeType = view.state.schema.nodes.image;

        const position =
            event.type === "drop"
                ? view.posAtCoords({ left: event.clientX, top: event.clientY })
                : null;

        insertImageFiles({ view, files, nodeType, position });

        return files.length > 0;
    };

    onMount = (event) => {
        const state = event.viewProps.state;
        const plugins = [
            ...state.plugins,
            insertImagePlugin(this.onImageInsert),
        ];

        return new ProseMirror.EditorView(
            { mount: event.dom },
            {
                ...event.viewProps,
                state: ProseMirror.EditorState.create({
                    doc: state.doc,
                    plugins,
                }),
            }
        );
    };

    UploadAttachement = async (event) => {
        let attachmentsName = [];
        let uploadFormData = new FormData();
        let counter = 0;
        for (let attachment of event.affectedFiles) {
            if (!attachment.validationErrors) {
                uploadFormData.append(
                    `file[${counter}]`,
                    attachment.getRawFile(),
                    attachment.name
                );
                ++counter;
            }
        }
        let uploadRequest = await callApiWithAuthorization(
            "/api/v0/uploadPlanningImage",
            {
                method: "POST",
                body: uploadFormData,
            }
        );
        const uploadResponse = await uploadRequest.json();
        // let { AttachmentsData } = this;
        // AttachmentsData = [...AttachmentsData, ...attachmentsName];
        // this.AttachmentsData = AttachmentsData;
        // this.checkAttachment()
        // this.props.onAttachmentsChange(attachmentsName)
    };

    addFile = (event) => {
        if (event.newState.length < 4) {
            let { name } = event.target.props;
            this.setState({
                [name]: event.newState,
            });
        }
        if (event.newState.length + this.state.attachments.length > 3) {
            this.setState({
                showAttachmentsMessage: true,
            });
        }
    };

    removeFile = (event) => {
        let { name } = event.target.props;
        this.setState({
            [name]: event.newState,
        });

        if (event.newState.length + this.state.attachments.length < 4) {
            this.setState({
                showAttachmentsMessage: false,
            });
        }
        // this.props.onAttachmentsChange(event.newState)
    };

    removeAttachment = () => {
        const { Attachments: prevAttachments, deletedAttachments } = this.state;
        const removedAttachmentIndex = prevAttachments.findIndex(
            (attachment) => attachment.id === this.state.selectedAttachment.id
        );
        deletedAttachments.push(prevAttachments[removedAttachmentIndex]);
        const Attachments = prevAttachments.filter(
            (attachment) => attachment.id !== this.state.selectedAttachment.id
        );
        this.setState({
            Attachments,
            deletedAttachments,
        });
        this.hideRemoveAttachmentDialog();
    };

    closeFormDialog = (e) => {
        let { ...cardData } = this.state;
        let action = "update";
        if (this.state.isNew) {
            action = "create";
        }
        this.props.closeFormDialog({
            cardData,
            action,
        });
    };

    toggleDeleteDialog = (e) => {
        this.setState({
            showDeleteDialog: !this.state.showDeleteDialog,
        });
    };

    showRemoveAttachmentDialog = (attachment) => {
        this.setState({
            showRemoveAttachment: true,
            selectedAttachment: attachment,
        });
    };

    hideRemoveAttachmentDialog = (e) => {
        this.setState({
            showRemoveAttachment: false,
            selectedAttachment: "",
        });
    };

    onSubmit = (event, action) => {
        const { saveButton } = this;
        if (saveButton.current) {
            saveButton.current.disabled = true;
        }
        let {
            assigneeData,
            priorityData,
            tagsData,
            cardTypeData,
            colorData,
            stateData,
            shouldAdd,
            tagsHtmlAttributes,
            isNew,
            cover,
            deletedAttachments,
            ...cardData
        } = this.state;

        let newTags = [];
        for (let tags of cardData.tags) {
            let newTagsFound = !tagsData.includes(tags);
            if (newTagsFound) {
                newTags.push(tags);
            }
        }

        tagsData = [...tagsData, ...newTags];

        if (cardData.tags instanceof Array)
            cardData.tags = cardData.tags.join(",");

        cardData.newAttachments = cover;
        cardData.deletedAttachments = deletedAttachments;
        cardData.attachments = [...cardData.attachments];
        cardData.assignTo = cardData.assignTo ? cardData.assignTo.email : "";

        this.props.submitFormDialog({
            event,
            cardData,
            action,
            tagsData,
        });
    };
}

export default Planning;
